import type { UserRole } from '@/lib/types';

export const COMPANY_ROLE_OPTIONS: ReadonlyArray<{
  value: UserRole;
  label: string;
  description: string;
}> = [
  { value: 'Admin', label: 'Admin', description: 'Full access, including users and organization settings' },
  { value: 'Manager', label: 'Manager', description: 'Manage operations without changing organization settings' },
  { value: 'Inspector', label: 'Inspector', description: 'Conduct inspections and create and sign JSAs' },
  { value: 'Supervisor', label: 'Supervisor', description: 'Create documents and run talks' },
  { value: 'User', label: 'User', description: 'Interact with documents and assigned work' },
  { value: 'Viewer', label: 'Viewer', description: 'Read-only access to company data' },
];
